//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import ToggleButtonGroup from 'components/Shared/ToggleButtonGroup/Index'

const ToggleButtonGroupField = ({
  name, disabled, validate, buttons, useFullWidth,
}) => {
  return (
    <Field
      name={name}
      validate={validate}
    >
      {({ input, meta }) => {
        return (
          <ToggleButtonGroup
            value={input.value}
            onChange={input.onChange}
            disabled={disabled}
            buttons={buttons}
            useFullWidth={useFullWidth}
          />
        )
      }}
    </Field>
  )
}

ToggleButtonGroupField.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  validate: PropTypes.func,
  buttons: PropTypes.array.isRequired,
  useFullWidth: PropTypes.bool,
}

export default ToggleButtonGroupField
